import { gql, useQuery } from '@apollo/client';

export const GET_ACCOUNT_DELIVERY_DRIVERS_BY_WAREHOUSE_ID_FOR_REVIEW = gql`
    query GetAccountDeliveryDriversByWarehouseIdForReview($warehouseId: Long!) {
        accountDeliveryDriversByWarehouseId: getAccountDeliveryDriversByWarehouseIdForReview(warehouseId: $warehouseId) {
            id
            accountId
            isOnDuty
            driverName
            driverPhone
        }
    }
`;

export interface DepartureDriverType {
    id: string;
    accountId: string;
    isOnDuty: boolean;
    driverName: string;
    driverPhone: string;
}

export interface GetAccountDeliveryDriversByWarehouseIdForReviewResponse {
    accountDeliveryDriversByWarehouseId: DepartureDriverType[];
}

export interface GetAccountDeliveryDriversByWarehouseIdForReviewVariables {
    warehouseId: number;
}

export const useAccountDepartureDriversByWarehouseId = (warehouseId: number | null) => {
    const { data, loading, error, refetch } = useQuery<
        GetAccountDeliveryDriversByWarehouseIdForReviewResponse,
        GetAccountDeliveryDriversByWarehouseIdForReviewVariables
    >(GET_ACCOUNT_DELIVERY_DRIVERS_BY_WAREHOUSE_ID_FOR_REVIEW, {
        variables: { warehouseId: warehouseId || 0 },
        skip: warehouseId === null || warehouseId === 0,
        fetchPolicy: 'cache-and-network',
        errorPolicy: 'all'
    });

    return {
        accountDeliveryDriversByWarehouseId: data?.accountDeliveryDriversByWarehouseId || [],
        loading,
        error,
        refetch
    };
};
